export const convertLangById = id => {
  switch (Number(id)) {
    case -1:
      return 'all';
    case 0:
      return 'es';
    case 1:
      return 'pt';
    default:
      return '';
  }
};
